import numeral from "numeral";

let initialValue = "";

export function getTitle() {
  return initialValue;
}

export function setTitle(params) {
  initialValue = params;
}
export function currFormat(num) {
  let a = Number(num);
  return numeral(a).format("0,0");
}
